import type { ReactNode } from 'react';
import { ApiError } from '../api/client.js';
import { Alert, Spinner, cx } from './ui.js';
import s from './Page.module.css';

export function Page({ children, wide }: { children: ReactNode; wide?: boolean }) {
  return <div className={cx(s.page, wide && s.wide)}>{children}</div>;
}

export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: ReactNode; description?: ReactNode; actions?: ReactNode }) {
  return (
    <header className={s.header}>
      <div>
        {eyebrow && <span className="label">{eyebrow}</span>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className={s.actions}>{actions}</div>}
    </header>
  );
}

export function Loading() {
  return (
    <div className={s.center}>
      <Spinner />
    </div>
  );
}

export function ErrorView({ error }: { error: unknown }) {
  const message = error instanceof ApiError ? error.message : 'Something went wrong loading this page.';
  return (
    <div className={s.center}>
      <Alert>{message}</Alert>
    </div>
  );
}

export function errorMessage(err: unknown): string {
  return err instanceof ApiError ? err.message : err instanceof Error ? err.message : 'Something went wrong.';
}
